import React from 'react';
import PropTypes from 'prop-types';
import { SubmissionError } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'qs';
//
import {
  login,
  logout,
  resendMFAValidationCode,
  validateMFACode,
} from 'store/actions/auth.actions';
import { getReduxFormError } from 'utils/forms/getReduxFormError';
import { ROUTES } from 'config/constants';
import { LoginForm } from './LoginForm';
import { MfaCodeForm } from './MfaCodeForm';
import { isCompletedAuth } from 'utils/auth';

@connect(
  ({ authState }) => ({
    authState,
  }),
  (dispatch) => ({
    login: bindActionCreators(login, dispatch),
    logout: bindActionCreators(logout, dispatch),
    resendMFAValidationCode: bindActionCreators(
      resendMFAValidationCode,
      dispatch,
    ),
    validateMFACode: bindActionCreators(validateMFACode, dispatch),
  }),
)
export default class LoginPage extends React.PureComponent {
  static propTypes = {
    authState: PropTypes.object,
  };

  static defaultProps = {
    authState: {},
  };

  handleSubmit = async (values) => {
    const { history } = this.props;

    const response = await this.props.login(values);
    const userIsDeleted =
      response.code === 'sec.forbidden' &&
      response.errors.some((item) => item.code === 'bus.user_is_deleted');

    if (userIsDeleted) {
      history.push(ROUTES.DELETED_USER);
    }
    if (response?.code !== 'success') {
      throw new SubmissionError(getReduxFormError(response));
    }

    if (!isCompletedAuth(response.data)) {
      // is response is valid but authentication is not completed disable redirect to perform MFA
      return;
    }

    const {
      location: { search = '' },
    } = this.props;
    const { redirectUrl = '' } = parse(search, { ignoreQueryPrefix: true });
    if (redirectUrl) {
      history.push(redirectUrl);
    }
  };

  handleMFASubmit = async (values) => {
    const { history } = this.props;
    const response = await this.props.validateMFACode(values);
    if (response?.code !== 'success') {
      throw new SubmissionError(getReduxFormError(response));
    }
    const {
      location: { search = '' },
    } = this.props;
    const { redirectUrl = '' } = parse(search, { ignoreQueryPrefix: true });
    if (redirectUrl) {
      history.push(redirectUrl);
    }
  };

  render() {
    const { authState = {} } = this.props;
    const { isAuthProcessed } = authState;

    return authState.accessToken && !authState.isAuth ? (
      <MfaCodeForm
        isFormProcessed={isAuthProcessed}
        onSubmit={this.handleMFASubmit}
        onBackToLogin={this.props.logout}
        onResendCode={this.props.resendMFAValidationCode}
      />
    ) : (
      <LoginForm
        isFormProcessed={isAuthProcessed}
        onSubmit={this.handleSubmit}
      />
    );
  }
}
